module.exports = __webpack_public_path__ + "icon_yrittaja.9e37f3ae2d7d9720a361.svg";